module.exports = __webpack_public_path__ + "static/media/heart_active.9571fb3d.svg";